import { Box, Paper, Stack, Typography } from "@mui/material";
import { formatInteger, formatPercent } from "../formatters";
import { FunnelStep } from "./usersApiMapping";

interface UsersFunnelProps {
  steps: FunnelStep[];
  total: number;
}

export default function UsersFunnel({ steps, total }: UsersFunnelProps) {
  const max = Math.max(1, total);

  return (
    <Paper variant="outlined" sx={{ p: "20px 24px", borderColor: "#ececec" }}>
      <Typography sx={{ mb: 2.25, fontSize: 16, fontWeight: 500, color: "#1a1a1a" }}>
        Main Funnel
      </Typography>
      <Stack spacing={1.25}>
        {steps.map((step, index) => {
          const widthPercent = (step.count / max) * 100;
          const isLast = index === steps.length - 1;
          const percentOfTotal = total ? (step.count / total) * 100 : 0;

          return (
            <Stack key={step.label} direction="row" alignItems="center" spacing={1.75}>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ width: 150, textAlign: "right" }}
              >
                {step.label}
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  height: 30,
                  borderRadius: 1,
                  backgroundColor: "#f3f3f5",
                  position: "relative",
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    left: `${(100 - widthPercent) / 2}%`,
                    width: `${widthPercent}%`,
                    height: "100%",
                    backgroundColor: isLast ? "#7CB342" : "#8E24AA",
                    opacity: 0.45 + 0.5 * (1 - index / 12),
                  }}
                />
                <Typography
                  variant="body2"
                  fontWeight={700}
                  sx={{
                    position: "relative",
                    width: "100%",
                    textAlign: "center",
                    color: widthPercent > 14 ? "#fff" : "#616161",
                  }}
                >
                  {formatInteger(step.count)}
                </Typography>
              </Box>
              <Typography
                variant="body2"
                fontWeight={600}
                color="#8E24AA"
                sx={{ width: 64, textAlign: "right" }}
              >
                {formatPercent(percentOfTotal, 2)}
              </Typography>
            </Stack>
          );
        })}
      </Stack>
    </Paper>
  );
}
